/* eslint-disable */
// Deprecated. To be removed when reports refresh is finalized.
import * as ShowMediaModal from '@/app/store/actions';
import Dialog from '@material-ui/core/Dialog';
import Close from '@material-ui/icons/Close';
import makeStyles from '@material-ui/styles/makeStyles';
import React from 'react';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles(() => ({
	backDrop: {
		backdropFilter: 'blur(10px)',
		backgroundColor: 'rgba(0,0,30,0.4)',
	},
}));
const OnlyMediaComponent = ({ media }) => {
	const [pictureLarge, setPictureLarge] = React.useState(null);
	const classes = useStyles();
	const dispatch = useDispatch();

	return (
		<>
			{pictureLarge ? (
				<Dialog
					BackdropProps={{
						classes: {
							root: classes.backDrop,
						},
					}}
					onClose={() => {
						setPictureLarge(null);
					}}
					open={pictureLarge}
				>
					<div className="larg_image flex flex-col">
						<div className="self-end cursor-pointer absolute profile-close" onClick={() => setPictureLarge(null)}>
							<Close />
						</div>
						<img src={pictureLarge} />
					</div>
				</Dialog>
			) : null}
			<div className="bg-white images-popup">
				<div className="flex justify-between images-popup-header">
					<div />
					<div>
						<i
							className="fas text-[20px]"
							onClick={() => dispatch(ShowMediaModal.closeMediaDialog())}
							style={{ cursor: 'pointer' }}
						/>
					</div>
				</div>
				<div className="media-list-cont w-full" id="scrollable-list">
					{media.map((item, index) => {
						return (
							<div className="flex-1" key={index}>
								{item.type === 'image' ? (
									<img
										onClick={() => {
											setPictureLarge(item.link);
										}}
										// crossOrigin="*"
										src={item.link}
										style={{
											margin: '16px 0px',
											width: '100%',
											height: 300,
											backgroundColor: 'black',
											objectFit: 'contain',
										}}
									/>
								) : (
									<video
										controls
										poster={item.thumb}
										src={item.link}
										style={{
											margin: '16px 0px',
											width: '100%',
											height: 300,
											objectFit: 'contain',
											backgroundColor: 'black',
										}}
									/>
								)}
							</div>
						);
					})}
				</div>
			</div>
		</>
	);
};

export default OnlyMediaComponent;
